import styled from 'styled-components';

export const ChartsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
